module.exports = __webpack_public_path__ + "static/scale-model-of-trundle-manor-in-pittsburgh-pennsylvania-aeb094fe68d3023177e2f37080927843.png";